import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex bg-yellow-100 rounded-lg p-2 text-sm leading-5 font-normal text-gray-800 items-center gap-x-2 w-full"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }

import { computed } from "vue"
import { formatHumanReadableDate } from "@/shared/utils/helpers"
import DNDIcon from "@/components/icons/DNDIcon.vue"
import { Lead } from "@/shared/models/lead"
import { InboxContact } from "@/shared/models/inbox"

interface Props {
    recipients: Lead[] | InboxContact[]
    showLeadName?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DNDWarningComponent',
  props: {
    recipients: {},
    showLeadName: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const hasDND = computed(() =>
    props.recipients.some(
        (recipient) =>
            recipient.doNotDisturb?.isEnabled &&
            new Date() >= new Date(recipient.doNotDisturb.startDate as Date) &&
            new Date() <= new Date(recipient.doNotDisturb.endDate as Date)
    )
)

return (_ctx: any,_cache: any) => {
  return (hasDND.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DNDIcon, { class: "w-4 h-4" }),
        _createElementVNode("p", null, [
          (_ctx.recipients.length > 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "Some leads have"))
            : (_ctx.showLeadName)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.recipients[0].fullName || `${_ctx.recipients[0].firstName} ${_ctx.recipients[0].lastName}`), 1),
                  _createTextVNode(" has")
                ]))
              : _createCommentVNode("", true),
          _createTextVNode(" Do Not Disturb enabled "),
          (_ctx.recipients.length === 1)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _createTextVNode("until "),
                _createElementVNode("b", null, _toDisplayString(_unref(formatHumanReadableDate)(new Date(_ctx.recipients[0].doNotDisturb?.endDate), false)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})